import light from './light.theme'
import dark from './dark.theme'
import heroSimple from './heroSimple.theme'

export default {
  light,
  dark,
  heroSimple
}
